var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20 15.5 12.125 2 2 20h15.75","stroke":"var(--v-primary-base)","stroke-width":"2","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }